import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import SnackbarContent from "@material-ui/core/SnackbarContent";

import i18n from '../../../i18n';
import Layout from '../../../components/Layout';
import CsrfField from "../../../components/Form/CsrfField";
import FormField from "../../../components/Form/FormField";
import styles from '../styles';

const Email = ({classes, session, errors}) => (
    <Layout>
        <div className={classes.main}>
            {session.status && (
                <SnackbarContent
                    className={classes.success}
                    aria-describedby="client-snackbar"
                    message={(
                        <span id="client-snackbar">
                            {session.status}
                        </span>
                    )}
                />
            )}

            <Paper className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <Icon>restore</Icon>
                </Avatar>

                <Typography
                    component="h1"
                    variant="h5"
                    align="center"
                >
                    {i18n.get('user.password.reset')}
                </Typography>

                <form
                    method="POST"
                    action="/password/email"
                    className={classes.form}
                >
                    <CsrfField/>

                    <FormField
                        id="email"
                        type="email"
                        name="email"
                        label={i18n.get('user.form.email')}
                        touched={errors.email}
                        error={errors.email && errors.email[0]}
                    />

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.spaceButton}
                    >
                        {i18n.get('user.password.resetsend')}
                    </Button>
                </form>
            </Paper>
        </div>
    </Layout>
);

export default withStyles(styles)(Email);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/auth/passwords/Email.jsx